import React, { useRef } from 'react';
import { shape, string } from 'prop-types';
import { Card, CardContent, Divider } from '@mui/material';
import { useParams } from 'react-router-dom';

// utils
import { useUserRolePermissions } from 'hooks';
import { CARD_MARGIN, CARD_WIDTH } from 'utils/constants';

// components
import Title from './title/Title.connector';
import Body from './body/Body';
import ButtonSelect from './button-select/ButtonSelect.connector';
import Labels from './labels/Labels';

const SelfAuthorizationCard = ({ currentSelectionNameShort, listType, selfAuthorization }) => {
  const { viewBy } = useParams();
  const cardType = viewBy === 'location' ? 'product' : 'location';
  const { authorizationCount, lastUsed } = selfAuthorization.activeAuthorization || {};
  const node = useRef();
  const { isProductLoadingManage } = useUserRolePermissions();

  return (
    <Card
      ref={node}
      sx={{
        borderRadius: '2px',
        boxShadow: 6,
        height: 'auto',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        mb: { xs: 0, sm: CARD_MARGIN },
        minHeight: 234,
        mt: 1,
        mx: 1,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        width: { xs: '100%', sm: CARD_WIDTH },
      }}
    >
      <CardContent
        sx={{
          ':last-child': {
            pb: 2,
          },
          columnGap: 2,
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          height: '100%',
          justifyItems: 'center',
          p: 2,
          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
          rowGap: 1,
        }}
      >
        <Title
          authorizationCount={authorizationCount}
          cardData={selfAuthorization[cardType]}
          currentSelectionNameShort={currentSelectionNameShort}
          isProprietaryProduct={selfAuthorization[cardType].proprietary}
          listType={listType}
          title={selfAuthorization[cardType].nameShort}
        />
        <Divider sx={{ gridColumn: '1 / 3', height: '1px', width: '100%' }} />
        {/* <Divider sx={{ gridColumn: '1 / 2', height: '1px', width: '100%' }} />
        <Divider sx={{ gridColumn: '2 / 3', height: '1px', width: '100%' }} /> */}
        <Body authorizationCount={authorizationCount} lastUsed={lastUsed} listType={listType} />
        {isProductLoadingManage ? (
          <ButtonSelect listType={listType} selfAuthorization={selfAuthorization} />
        ) : (
          <Labels activeAuthorization={selfAuthorization.activeAuthorization} listType={listType} />
        )}
      </CardContent>
    </Card>
  );
};

export default SelfAuthorizationCard;

SelfAuthorizationCard.propTypes = {
  currentSelectionNameShort: string.isRequired,
  // index: number.isRequired,
  listType: string,
  selfAuthorization: shape({}).isRequired,
};

SelfAuthorizationCard.defaultProps = {
  listType: '',
};
